import {
  GenericSuggestion,
  SuggestionPipelines,
} from 'types/suggestions/CoreSuggestions';
import { SuggestionStatus } from 'types/suggestions/LoadSuggestions';
import { SuggestedQuoteChange } from 'types/suggestions/QuoteSuggestions';

/**
 * Apply handled statuses from this session to the latest API suggestions.
 * This keeps quoted and dismissed lanes handled before the next refetch.
 */
export function withSessionStatus(
  apiSuggestions: GenericSuggestion[],
  sessionSuggestions: GenericSuggestion[]
): SuggestedQuoteChange[] {
  const sessionSuggestionsById = new Map(
    sessionSuggestions
      .filter(
        (suggestion): suggestion is SuggestedQuoteChange =>
          suggestion.pipeline === SuggestionPipelines.QuickQuote
      )
      .map((suggestion) => [suggestion.id, suggestion])
  );
  const sessionStatusesById = new Map<number, SuggestionStatus>();
  for (const suggestion of sessionSuggestions) {
    if (
      suggestion.pipeline === SuggestionPipelines.QuickQuote &&
      (suggestion.status === SuggestionStatus.Accepted ||
        suggestion.status === SuggestionStatus.Rejected)
    ) {
      sessionStatusesById.set(suggestion.id, suggestion.status);
    }
  }

  return apiSuggestions
    .filter(
      (s): s is SuggestedQuoteChange =>
        s.pipeline === SuggestionPipelines.QuickQuote
    )
    .map((suggestion) => {
      const sessionSuggestion = sessionSuggestionsById.get(suggestion.id);
      if (sessionSuggestion?.status === SuggestionStatus.Pending) {
        return sessionSuggestion;
      }

      const sessionStatus = sessionStatusesById.get(suggestion.id);
      return sessionStatus
        ? { ...suggestion, status: sessionStatus }
        : suggestion;
    });
}
